import { testimonials } from "@/mocks/blog";

export default function AboutSection() {
  return (
    <section id="about" className="bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <div className="grid items-center gap-10 lg:grid-cols-2">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-accent-600">ABOUT ME</p>
            <h2 className="mt-2 font-display text-2xl font-bold text-foreground-950 md:text-3xl">
              关于我 · <span className="text-primary-600">一个认真吃瓜的普通人</span>
            </h2>
            <p className="mt-5 text-[15px] leading-[1.9] text-foreground-700">
              你好，我是<strong className="font-semibold text-foreground-900">吾爱吃瓜</strong>。我不追星、不站队、不生产新闻，
              只是一个喜欢把热点事件看透、想明白，再老老实实写下来的普通网友。
            </p>
            <p className="mt-3 text-[15px] leading-[1.9] text-foreground-700">
              写了六年，我越来越确信：比起一堆二手情绪，我更愿意给读者<strong className="font-semibold text-foreground-900">一套看问题的方法</strong>。
              我的观点未必正确，但一定真实。这里没有广告软文，只有我个人的吃瓜心得与碎碎念，以及一点点不合时宜的清醒。
            </p>

            <ul className="mt-6 space-y-3">
              {[
                { icon: "ri-eye-2-line", text: "只写主观看法，拒绝通稿式讨好" },
                { icon: "ri-scales-3-line", text: "用事实框住观点，先厘清再表态" },
                { icon: "ri-heart-3-line", text: "共情每个普通人，不说风凉话" },
              ].map((item) => (
                <li key={item.text} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-600">
                    <i className={`${item.icon} text-sm`} aria-hidden="true"></i>
                  </span>
                  <span className="text-sm text-foreground-700 md:text-[15px]">{item.text}</span>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-display text-lg font-bold text-foreground-900">读者朋友们怎么说</h3>
            <div className="mt-5 space-y-4">
              {testimonials.map((t, i) => (
                <figure key={i} className="rounded-lg border border-background-200 bg-background-50 p-5">
                  <div className="flex gap-0.5 text-secondary-500">
                    {Array.from({ length: 5 }).map((_, s) => (
                      <i key={s} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-[15px] leading-relaxed text-foreground-700">
                    "{t.text}"
                  </blockquote>
                  <figcaption className="mt-3 flex items-center gap-2 text-sm">
                    <span className="flex h-8 w-8 items-center justify-center rounded-full bg-accent-100 font-display text-accent-700">
                      {t.who.charAt(0)}
                    </span>
                    <span className="font-semibold text-foreground-900">{t.who}</span>
                    <span className="text-foreground-400">· {t.role}</span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}